module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.reqId
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading py-0 pl-0"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.noteRequest.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.getNotes
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), (_vm.notes && _vm.notes.length > 0) ? _c('span', [_vm._v("\n    " + _vm._s(_vm.$tc('summary', _vm.notes.length, {
    count: _vm.notes.length,
    date: _vm.dateformat(_vm.notes[_vm.notes.length - 1].created_date)
  })) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("toolbar-buttons")], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.withAdd) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "absolute": "",
      "top": "",
      "right": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.selectedNote = null;
        _vm.showNotes = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (_vm.clientId) ? _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.showNotes),
      callback: function($$v) {
        _vm.showNotes = $$v
      },
      expression: "showNotes"
    }
  }, [_c('v-card', [_c('notes', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "note:deleted": function($event) {
        _vm.getNotes();
        _vm.showNotes = false
      },
      "close": function($event) {
        _vm.showNotes = false
      }
    },
    model: {
      value: (_vm.selectedNote),
      callback: function($$v) {
        _vm.selectedNote = $$v
      },
      expression: "selectedNote"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.noteRequest.loading) ? _c('tombstone') : [(_vm.notes && _vm.notes.length > 0) ? _c('v-timeline', {
    attrs: {
      "align-top": "",
      "dense": ""
    }
  }, _vm._l((_vm.notesToShow), function(note, index) {
    return _c('v-timeline-item', {
      key: ("note-" + (note.id) + "-" + index),
      attrs: {
        "color": "pink",
        "small": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "pt-3": "",
        "row": "",
        "wrap": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "absolute": "",
        "small": "",
        "right": "",
        "fab": "",
        "flat": "",
        "text": "",
        "disabled": !_vm.canEdit(note)
      },
      on: {
        "click": function($event) {
          _vm.selectedNote = note;
          _vm.showNotes = true
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": ""
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.dateformat(note.date)))]), _c('br'), _vm._v(" "), _c('small', [_vm._v("created " + _vm._s(_vm.dateformat(note.created_date)))]), _c('br'), _vm._v(" "), _c('practitioner-faces', {
      attrs: {
        "practitioner-ids": note.owners,
        "size": 18
      }
    }, [_c('small', {
      staticClass: "caption"
    }, [_vm._v("created by")])]), _vm._v(" "), _c('br'), _vm._v(" "), (note.spaces && note.spaces.length > 0) ? _c('space-faces', {
      attrs: {
        "size": 16,
        "space-ids": note.spaces
      }
    }, [_c('span', {
      staticClass: "caption",
      attrs: {
        "slot": "prepend"
      },
      slot: "prepend"
    }, [_vm._v("shared with")])]) : _c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "color": "amber",
        "label": ""
      }
    }, [_vm._v("Private")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm9": ""
      }
    }, [_c('strong', [_vm._v(_vm._s(note.title))]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "mt-2",
      domProps: {
        "innerHTML": _vm._s(_vm.markdown(note.text))
      }
    }), _vm._v(" "), _vm._l((note.object_ids), function(obj) {
      return _c('object-chip', {
        key: ("obj-" + obj),
        staticClass: "ml-0",
        attrs: {
          "small": "",
          "object": obj
        }
      })
    }), _vm._v(" "), (note.documents && note.documents.length > 0) ? _c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-chip', _vm._g({
            attrs: {
              "slot": "activator",
              "small": "",
              "icon": ""
            },
            slot: "activator"
          }, on), [_vm._v("\n                  Files\n                  "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), (note && note.documents) ? _c('v-list', {
      staticClass: "pa-0",
      attrs: {
        "dense": ""
      }
    }, _vm._l((note.documents), function(doc) {
      return _c('v-list-tile', {
        key: doc.name,
        attrs: {
          "href": doc.file,
          "target": "_blank"
        }
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(doc.name))])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("open_in_new")])], 1)], 1)
    }), 1) : _vm._e()], 1) : _vm._e()], 2)], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.notesExist) ? _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": !_vm.areMoreNotesToShow,
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.numNotesToShow += _vm.pageSize
      }
    }
  }, [_vm._v("Load more")])], 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        No notes found.\n        "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.getNotes
    }
  }, [_vm._v("Reload")]), _vm._v(" "), (_vm.withAdd) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "outline": "",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedNote = null;
        _vm.showNotes = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n          New note\n        ")], 1) : _vm._e()], 1)], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a19d46f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoteList.vue
// module id = 1476
// module chunks = 9